import clsx from 'clsx';
import { GlowImage } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { HtmlHelpers } from '@headless-workspace/utils';

type ProductDetailFooterSectionProps = {
    vipFooterLogoUrl?: string;
    brandLogoPosition: string;
    brandName: string;
};

const VIP_LOGO_ALT_TEXT = 'Brand Authorized Reseller Logo';

export const ProductDetailFooterSection: Component<ProductDetailFooterSectionProps> = ({
    vipFooterLogoUrl,
    brandLogoPosition,
    brandName,
}) => {
    const brandFooterLogoAlt = `${brandName} ${VIP_LOGO_ALT_TEXT}`;

    return (
        vipFooterLogoUrl && (
            <div
                className={clsx(
                    'flex w-fullViewport self-center',
                    'border-solid border-t-[0.5rem] border-t-border-brand',
                    HtmlHelpers.getStylePosition(brandLogoPosition),
                )}
            >
                <GlowImage
                    className={'w-full flex justify-center py-1.5'}
                    imgClassName={'h-[9.875rem]'}
                    image={{
                        src: vipFooterLogoUrl,
                        alt: brandFooterLogoAlt,
                    }}
                    fetchPriority={'low'}
                    loading={'lazy'}
                />
            </div>
        )
    );
};
